import gsap from "gsap";

export default {
  init: () => {
    const accordionTriggers = document.querySelectorAll('[data-accordian-trigger]');
    const accordionContents = document.querySelectorAll('[data-accordian-content]');

    accordionContents.forEach((content) => {
      const isExpanded = content.getAttribute('aria-expanded') === 'true';
      const accordionWrapper = content.closest('.accordion-wrapper');
      const wrapperHeight = accordionWrapper.offsetHeight;

      gsap.set(content, {
        y: isExpanded ? 0 : 50,
        opacity: isExpanded ? 1 : 0,
        height: isExpanded ? "auto" : 0,
        visibility: isExpanded ? "visible" : "hidden",
        maxHeight: `${wrapperHeight + 45}px`,
        overflowY: "scroll",
        overflowX: "hidden"
      });
    });

    accordionTriggers.forEach((trigger) => {
      const controls = trigger.getAttribute('aria-controls');
    const targetContent = trigger.closest('.accordion-wrapper').querySelector(`#${controls}`);
      const accordianItem = targetContent.querySelectorAll('[data-accordian-content-item]');
      const hideSiblings = trigger.hasAttribute('data-accordion-hide-siblings');

      trigger.addEventListener('click', () => {
        const isExpanded = targetContent.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          trigger.setAttribute('aria-expanded', 'false');
          gsap.to(targetContent, {
            y: 50,
            opacity: 0,
            height: 0,
            visibility: "hidden",
            duration: 0.5,
            ease: "power3.out",
          });
          trigger.classList.remove('active');
          targetContent.setAttribute('aria-expanded', 'false');
        } else {
          trigger.setAttribute('aria-expanded', 'true');

          if (hideSiblings) {
            accordionContents.forEach((content) => {
              gsap.set(content, {
                y: 50,
                opacity: 0,
                height: 0,
                visibility: "hidden",
                duration: 0.5,
                ease: "power3.out",
              });
              content.setAttribute('aria-expanded', 'false');
            });

            accordionTriggers.forEach((item) => item.classList.remove('active'));
          }

          targetContent.setAttribute('aria-expanded', 'true');
          gsap.to(targetContent, {
            y: 0,
            opacity: 1,
            height: "auto",
            visibility: "visible",
            duration: 0.5,
            ease: "power3.out",
          });

          if (accordianItem.length) {
           gsap.fromTo(accordianItem, {
              y: 50,
              opacity: 0,
            }, {
              y: 0,
              opacity: 1,
              stagger: 0.2,
              duration: 1,
              ease: "expo.out",
            });
          }

          trigger.classList.add('active');
        }
      });
    });
  },
};
